'use strict';

import 'readmore-js';
import {LISTING_CLASSES} from "../../../members/listings/create/js/constants";
import {AjaxDataLoad} from "../ajax-data-load/ajax-data-load";
import {url} from "../../../../shared/utils";
import * as Mustache from "mustache";

export const CompanyBox = (function() {

    const HTML_TEMPLATE_ID = 'company_box_template';

    let exports = {};

    exports.$container = null;

    exports.init = function(listingsContainerSelector) {
        if (!listingsContainerSelector || !$(listingsContainerSelector).length) {
            return;
        }

        if ($('#' + HTML_TEMPLATE_ID).length === 0) {
            return;
        }

        exports.$container = $(listingsContainerSelector);

        showBox();

        document.addEventListener('listings.page.drawn', (event) => {
            let listingClass = LISTING_CLASSES.full;

            if (event.detail && event.detail.style && LISTING_CLASSES[event.detail.style]) {
                listingClass = LISTING_CLASSES[event.detail.style];
            }

            retrieveCompanyBox(listingClass);
        });

        /*document.addEventListener('listings.style.changed', (event) => {
            toggleReadmore();
        });*/

        $(document).on('click', '.company-box .profile-box__company-name', function(e) {
            e.preventDefault();

            const target = this.href;
            const companyId = $(this).attr('data-track-id');
            trackCompanyProfileClickedEvent(companyId);

            setTimeout(() => {
                window.location = target;
            }, 200);
        });
    };

    function showBox() {
        exports.$container.find('.listings__company').show();
    }

    function showLoading() {
        exports.$container.find('.listings__company').addClass('skeleton');
    }

    function hideLoading() {
        exports.$container.find('.listings__company').removeClass('skeleton');
    }

    function retrieveCompanyBox(listingClass) {
        showLoading();

        const postData = AjaxDataLoad.getAjaxDataLoad();

        framework.get(url('api/get_sp_company'), postData,(r) => {
            if (r && r.company) {
                drawCompanyBox(r.company, listingClass);
                hideLoading();

                // if the box is drawn, track the event
                if ($('#cb_' + r.company.id).length > 0) {
                    trackBoxShownEvent(r.company.id);
                }

                toggleReadmore();
            }
        }, () => {
            hideLoading();
        });
    }

    function drawCompanyBox(company, listingClass) {
        const template = $('#' + HTML_TEMPLATE_ID).html();
        Mustache.parse(template);   // optional, speeds up future uses

        let render_data = {
            company:            company,
            // listingClass:       listingClass,
            isCertMember:       parseInt(company.is_cert_member) === 1 || company.is_cert_member === 'true',
            upgradeLinkText:    _data._show_member_listings ? 'Upgrade your plan' : 'Become a Member'
        };

        /*if (_data._show_member_listings) {
            render_data.listingClass += ' listing--members';
        }*/

        const rendered = Mustache.render(template, render_data);
        exports.$container.find('.listings__company').html(rendered);
    }

    function toggleReadmore() {
        // exports.$container.find('.company-box__readmore').readmore('destroy');
        exports.$container.find('.company-box__readmore').readmore({
            moreLink: '<button class="tl-btn-link">Read More <i class="tl-expand-small"></i></button>',
            lessLink: '<button class="tl-btn-link">Read Less <i class="tl-collapse-small"></i></button>'
        });
    }

    function trackBoxShownEvent(companyId) {
        if (!window.Analytics || !window.Analytics.track) {
            return;
        }

        const EVENT_ID = 326;
        let eventData = companyId;

        window.Analytics.track('14|0a. Marketing', {
            type_id: EVENT_ID,
            eventData: {
                "event_cat_id": 14,
                "event_cat_name": "0a. Marketing",
                "tl_event_id": EVENT_ID,
                "tl_event_name": '(Company Box) Box Shown',
                "tl_event_data": eventData
            },
            localData: {
                datavar: 'shown company box',
                datanum: eventData
            }
        });
    }

    function trackCompanyProfileClickedEvent(companyId) {
        if (!window.Analytics || !window.Analytics.track) {
            return;
        }

        const EVENT_ID = 327;
        let eventData = companyId;

        window.Analytics.track('17|3b. Viewed Listing/Profile', {
            type_id: EVENT_ID,
            eventData: {
                "event_cat_id": 17,
                "event_cat_name": "3b. Viewed Listing/Profile",
                "tl_event_id": EVENT_ID,
                "tl_event_name": '(Company Box) Viewed Company Profile',
                "tl_event_data": eventData
            },
            localData: {
                datavar: 'from company box',
                datanum: eventData
            }
        });
    }

    return exports;
})();